import React, { useState } from "react";
// import ContractOverview from "../../../../components/cards/ContractOverview";
import BuyerTable from "./BuyerTable";
import ChatBuyer from "./ChatBuyer";

// const metrics = [
//   { title: "Total Order", value: 30 },
//   { title: "Delivered", value: 2 },
//   { title: "Returns", value: 1 },
//   { title: "On the way", value: 1 },
// ];

const Buyer = () => {
  const [openChat, setOpenChat] = useState(false);

  return (
    <div className=" flex flex-col gap-6 p-4 sm:p-6 md:p-8 bg-gray-100 min-h-screen">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold mb-4">Buyer Detail</h1>
        {/* <div>
          <button
            className="text-accent text-sm font-semibold pointer"
            onClick={() => setOpenChat(true)}
          >
            Chat with Buyer
          </button>
        </div> */}
      </div>
      {/* <ContractOverview
        contractId="INT-0000000001"
        shopName="Nelly's order"
        status="Completed"
        metrics={metrics}
      /> */}
      <BuyerTable />
      <ChatBuyer isOpen={openChat} onClose={() => setOpenChat(false)} />
    </div>
  );
};

export default Buyer;
